<dx-form class="plain-styled-form" [screenByWidth]="getSizeQualifier">
    <dxi-item itemType="group">
        <dxo-col-count-by-screen
            [xs]="1"
            [sm]="3"
            [md]="3"
            [lg]="3"
        ></dxo-col-count-by-screen>
        <dxi-item [colSpan]="2">
            <div>Did the shipment arrive with a valid appointment?</div>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <dx-radio-group
                class="flex-shrink-0"
                layout="horizontal"
                [items]="yesNoOptions"
                valueExpr="value"
                displayExpr="text"
                [(value)]="formData.hasValidAppointment"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
                </dx-validator>
            </dx-radio-group>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <div>Was the delivery received on time?</div>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <dx-radio-group
                class="flex-shrink-0"
                layout="horizontal"
                [items]="yesNoOptions"
                valueExpr="value"
                displayExpr="text"
                [(value)]="formData.wasDeliveryOnTime"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
                </dx-validator>
            </dx-radio-group>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <div>Was a packing slip provided when required? (Vendors who to not have ASN )</div>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <dx-radio-group
                class="flex-shrink-0"
                layout="horizontal"
                [items]="yesNoOptions"
                valueExpr="value"
                displayExpr="text"
                [(value)]="formData.wasPackingSlipProvided"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
                </dx-validator>
            </dx-radio-group>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <div>Was the load free of damage or additional handling issues?</div>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <dx-radio-group
                class="flex-shrink-0"
                layout="horizontal"
                [items]="yesNoOptions"
                valueExpr="value"
                displayExpr="text"
                [(value)]="formData.wasLoadDamageFree"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
                </dx-validator>
            </dx-radio-group>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <div>Were ASN or tags provided when required?</div>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <dx-radio-group
                class="flex-shrink-0"
                layout="horizontal"
                [items]="yesNoOptions"
                valueExpr="value"
                displayExpr="text"
                [(value)]="formData.wasAsnOrTagsProvided"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
                </dx-validator>
            </dx-radio-group>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <div>Were the barcodes facing outward and fully scannable? </div>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <dx-radio-group
                class="flex-shrink-0"
                layout="horizontal"
                [items]="yesNoOptions"
                valueExpr="value"
                displayExpr="text"
                [(value)]="formData.wereBarcodesScannable"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
                </dx-validator>
            </dx-radio-group>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <div>Was the shipment free of excessive partial pallets?</div>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <dx-radio-group
                class="flex-shrink-0"
                layout="horizontal"
                [items]="yesNoOptions"
                valueExpr="value"
                displayExpr="text"
                [(value)]="formData.wasFreeOfExcessPartialPallets"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
                </dx-validator>
            </dx-radio-group>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <div>Did the ASN match the pallets and shipment quantity?</div>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <dx-radio-group
                class="flex-shrink-0"
                layout="horizontal"
                [items]="yesNoOptions"
                valueExpr="value"
                displayExpr="text"
                [(value)]="formData.didAsnMatchPalletsAndQuantity"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
                </dx-validator>
            </dx-radio-group>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <div>Was the shipment wrapped properly and stacked correctly?</div>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <dx-radio-group
                class="flex-shrink-0"
                layout="horizontal"
                [items]="yesNoOptions"
                valueExpr="value"
                displayExpr="text"
                [(value)]="formData.wasWrappedAndStackedProperly"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
                </dx-validator>
            </dx-radio-group>
        </dxi-item>  
        @if(this.showTrailerRequired)
        {
            <dxi-item [colSpan]="2">
                <div>Is the trailer required for outbound operations?</div>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dx-radio-group
                    class="flex-shrink-0"
                    layout="horizontal"
                    [items]="yesNoOptions"
                    valueExpr="value"
                    displayExpr="text"
                    [(value)]="formData.isTrailerRequiredForOutbound"
                >
                    <dx-validator>
                        <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-radio-group>
            </dxi-item>  
        }   
    </dxi-item>
</dx-form>